import { Filter } from './filter-state.model';

export class FilterStateSetFilterOptions {
  static readonly type = '[Filter] Set selected filter dropdown options for filter';

  constructor(public filter: Filter) {}
}
